var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality21(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.c,.g{fill:none;}.c,.d{stroke:#208ce1;stroke-width:1.5px;}.e{fill:#e2e8f3;}.f{stroke:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-1209 -7293)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1209 7293)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.385 -2.268)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1194.343-7277.075a11.267,11.267,0,0,1-5.279-3.167c-2.263-2.489-5.629-2.46-6.911-.952s-2.818,5.024,3.291,8.569"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-1204 -7275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 4,
    cy: 3.5,
    rx: 4,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 4,
    cy: 3.5,
    rx: 3.25,
    ry: 2.75
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1175.167 -7282.237)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1207.7-7277.075a11.267,11.267,0,0,0,5.279-3.167c2.263-2.489,5.629-2.46,6.911-.952s2.818,5.024-3.291,8.569",
    transform: "translate(1207.701 7282.237)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(1.657 7.237)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 4,
    cy: 3.5,
    rx: 4,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 4,
    cy: 3.5,
    rx: 3.25,
    ry: 2.75
  }))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1186.515-7249.227l-1.748-7.75a6.015,6.015,0,0,1,0-4.293c.87-2.437-.406-6.9-3.017-11.2s-2.785-4.351-1.682-5.917,7.442-3.962,12.178-2.5c2.671.824,5.132,2.275,5.534,3.436s-.776,2.765-.887,3.01c-1.682,3.713-5.511,6.555-4.931,12.241.394,1.333,1.174,1.792.928,3.478s-2.32,9.494-2.32,9.494"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-1189.363-7276.666s5.389-5.093,10.71.171a15.546,15.546,0,0,0-5.461-.482A44.477,44.477,0,0,0-1189.363-7276.666Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality21);
export default __webpack_public_path__ + "static/media/speciality21.6da719229035b8dc6395e994f9b447f8.svg";
export { ForwardRef as ReactComponent };